const UpdateBot = () => import('@/components/Bot/components/bot.update.components.vue')
const ListBot = () => import('@/components/Bot/components/bot.list.components.vue') 
const BuildHome = () => import('@/components/BuildBot/build.bot.template.vue')
const DashboardHome = () => import('@/components/Dashboard/dashboard.bot.template.vue')
const ManageHome = () => import('@/components/Manage/manage.bot.template.vue')
const SupportHome = () => import('@/components/Support/support.template.vue')


const ifAuthenticated = (to, from, next) => {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token)
    next()
    return
  }
  next()
}

import BluidRouter from './build.router.js'
import ManageRouter from './manage.router.js'
import DashboardRouter from './dasboard.router.js'
import SupportRouter from './support.router.js'

export default [
  {
    path: '',
    name: 'listBot',
    meta:{
      title: 'List App - Application Msl App'
    },
    component: ListBot,
    beforeEnter: ifAuthenticated
  },
  {
    path:'support',
    meta:{
      title: 'support'
    },
    component: SupportHome,
    children: SupportRouter,
    beforeEnter: ifAuthenticated
  },
  {
    path: ':id',
    name: 'updateBot',
    component: UpdateBot,
    meta:{
      title: 'update your App'
    },
    children: [  
      {
        path:'build',
        component: BuildHome,
        meta:{
          title: 'build'
        },
        children: BluidRouter,
        beforeEnter: ifAuthenticated
      },
      
      {
        path:'dashboard',
        meta:{
          title: 'dashboard'
        },
        component: DashboardHome,
        children: DashboardRouter,
        beforeEnter: ifAuthenticated
      },
      {
        path:'manage',
        meta:{
          title: 'manage'
        },
        component: ManageHome,
        children: ManageRouter,
        beforeEnter: ifAuthenticated
      }
      
    ],
   
  }
]


// WEBPACK FOOTER //
// ./src/router/bot.router.js